import React from 'react';
import LegacyComponent from './global-nav.legacy';
import DigComponent from './global-nav.dig';
import Vis2023FeatureFlagComponent from 'hellospa/common/strategies/vis-2023-feature-flag-component';
import { PropsOf } from 'js/sign-components/common/ts-utils';

const GlobalNav = (props: PropsOf<typeof DigComponent>) => {
  return (
    <Vis2023FeatureFlagComponent
      LegacyComponent={LegacyComponent}
      DigComponent={DigComponent}
      props={props}
    />
  );
};

export default GlobalNav;
